import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
`;

export const Left = styled.div`
  width: ${({ widthPcnt }) => widthPcnt}%;
  padding: 13px 11px;
  background: #e4e4e4;
  border-right: 0.5px solid #b4b4b4;
`;

export const Div = styled.div`
  width: ${({ widthPcnt }) => widthPcnt}%;
  border-right: 0.5px solid #b4b4b4;
  display: flex;
  flex-direction: row;
  align-items: center;
  ${({ noBorder }) => (noBorder ? 'border:none;' : '')}
`;
export const Radio = styled.input.attrs({ type: 'radio' })`
  margin: 0 6px 0 0;
`;
export const Label = styled.label`
  display: flex;
  align-items: center;
  margin: 0;
  margin-right: 16px;
`;
export const Reset = styled.img`
  margin: 0 11px 0 2px;
`;
export const Margin9px = styled.div`
  width: 9px;
`;
